export const ProductSegementData = [
   "Decking",
   "Fenching",
   "Cladding",
];
